// ---------------------------------------------------------------------------
// Permanent (301) redirect map: old Google-indexed URLs -> new canonical URLs.
// Keys are stored WITHOUT a trailing slash; the router matches the trailing
// slash variant automatically. This same map is mirrored in
// /public/_redirects and /public/serve.json for true server-side 301s at the
// hosting/CDN layer.
// ---------------------------------------------------------------------------

export const LEGACY_REDIRECTS = {
  "/american_us_english_child_kids_voiceover_samples": "/child-voices/american-english",
  "/british_uk_english_child_kids_voiceover_samples": "/child-voices/british-english",
  "/australian_english_child_kids_voiceover_samples": "/child-voices/australian-english",
  "/german_deutsch_child_kids_voiceover_samples": "/child-voices/german",
  "/french_francais_child_kids_voiceover_samples": "/child-voices/french",
  "/spanish_espagnol_child_kids_voiceover": "/child-voices/spanish",
  "/portuguese-portugal-kids-voices": "/child-voices/portuguese-portugal",
  "/italian_italie_child_kids_voiceover_samples": "/child-voices/italian",
  "/dutch_child_voice_over_samples_netherlands": "/child-voices/dutch",
  "/belgian_flemish_dutch_child_kids_voiceover_samples": "/child-voices/belgian-flemish",
  "/greek_greece_child_kids_voiceover_samples": "/child-voices/greek",
  "/danish_denmark_kids_voiceover_samples": "/child-voices/danish",
  "/finland_finnish_child_kids_voiceover_samples": "/child-voices/finnish",
  "/norwegian_norway_child_kids_voice_over_samples": "/child-voices/norwegian",
  "/swedish_sweden_child_kids_voice_over_samples": "/child-voices/swedish",
  "/russian_russia_soviet_union_child_kids_voiceover": "/child-voices/russian",
  "/poland-poles-polish-child-voices": "/child-voices/polish",
  "/romania_romanian_child_kids_voiceover": "/child-voices/romanian",
  "/chinese_china_child_kids_voiceover_samples": "/child-voices/chinese",
  "/japan_japanese_child_kids_voiceover_samples": "/child-voices/japanese",
  "/vietnamese_vietnam_child_kids_voiceover_samples": "/child-voices/vietnamese",
  "/portuguese-brazil-kids-voices": "/child-voices/portuguese-brazil",
  "/latin-south-american-spanish-kids-voices": "/child-voices/latin-american-spanish",
  "/arabic_child_kids_voiceover_samples": "/child-voices/arabic",
  "/afrikaans_south_africa_child_kids_voiceover_samples": "/child-voices/afrikaans",
  "/israel_hebrew_child_kids_voiceover_samples": "/child-voices/hebrew",
  // AI / synthetic child voices page
  "/ai_artificial_intelligence_child_kids_voices": "/ai-voices",
  // NOTE: /hindi_marathi_kannada_child_kids_voiceover/ is intentionally NOT
  // mapped — Hindi/Marathi/Kannada do not exist in the database, so it would
  // be inaccurate to redirect it to a real language page. Reported to owner.
};
